import PropTypes from 'prop-types';
import themeColors from '../../assets/styles/themeColors';
import EditIcon from '../Icons/Edit';
import Paragraph from '../Paragraph/Paragraph';
import { PreviewContainer, ReviewDataContainer } from '../ReviewElements';

const ReviewData = ({ title, onEdit, value, children }) => (
  <ReviewDataContainer>
    <Paragraph mb={8} fontWeight={700}>
      {title}
    </Paragraph>
    <PreviewContainer>
      {value ? (
        <Paragraph color={themeColors.colorTextXLLight} variant="normal">
          {value}
        </Paragraph>
      ) : (
        children
      )}
      <EditIcon onClick={() => onEdit()} />
    </PreviewContainer>
  </ReviewDataContainer>
);

ReviewData.propTypes = {
  title: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default ReviewData;
